import { SKILL_LIST } from '../index.js';
import Skill from '@/components/Skill';
export default {
  name: 'function',
  components: {
    Skill
  },
  data() {
    return {
      skillList: SKILL_LIST
    };
  }
};